var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTeayseer = function SvgTeayseer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1A2550",
    d: "M10.333 19.999c5.523 0 10-4.478 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10",
    opacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1A2550",
    d: "M13.08 14.999h2.253l-3.74-10h-2.55l-3.71 10h2.238l2.754-8.046z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#EC972D",
    d: "M11.358 12.765h-2.08v2.233h2.08z"
  })));
};
export default SvgTeayseer;